import axios from 'axios';

const removeBar = async (client_id) => {
    try {
        const token = localStorage.getItem('token'); // Substituído AsyncStorage por localStorage
        if (!token) {
            return {
                success: false,
                error: 'Usuário não autenticado.'
            };
        }

        const response = await axios.post(
            'https://apem.riderup.uk/api/removeBar',
            { client_id },
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );

        if (response.status === 200) {
            return {
                success: true,
                message: response.data.message
            };
        } else {
            return {
                success: false,
                error: response.data.message || 'Erro ao remover o bar.'
            };
        }
    } catch (error) {
        console.error('Erro ao remover o bar:', error);
        return {
            success: false,
            error: error.response?.data?.message || 'Erro ao conectar com a API.'
        };
    }
};

export default removeBar;
